/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LetterNew/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import DocumentTemplate from './DocumentTemplate/index'
import LetterRecipientPicker from 'DesignSystem/LetterRecipientPicker/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconSubtract from 'DesignSystem/Svgs/TysiaIconSubtract/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LetterNew({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Actions/Content/LetterNew"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let formPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'form',
path: 'patient.id',
})
let formActionRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'form',
path: 'action.recipient_id',
})
let formActionPostalAddressIdValueData = fromData.useDataValue({ viewPath,
context: 'form',
path: 'action.postal_address_id',
})
let onSave = fromHelpers.useOnSave({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="LetterNew.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1bsJny': dtColorsNeutral300,'--bblr-2-Z1bsJny': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z1bsJny': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z1bsJny': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z1bsJny': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="LetterNew.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-6-Z1bsJny': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-7-Z1bsJny': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-8-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-Z1bsJny': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="LetterNew.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-10-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="LetterNew.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-11-Z1bsJny': dtColorsNeutral200,'--pl-6-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={1}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Generate letter"
/>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 onClick={onClick}
 paddingRight={0}
 paddingLeft={0}
 marginTop={6}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconSubtract
{...childProps}
  viewPath={`${viewPath}/TysiaIconSubtract`}
 width={24}
 height={24}
 fill={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
<div
  data-testid="LetterNew.Vertical:2"
  data-view-path={viewPath}
 style={{'--pl-6-Z1bsJny': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-7-Z1bsJny': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-8-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1bsJny': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="LetterNew.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-10-Z1bsJny': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-9-Z1bsJny': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="LetterNew.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<DocumentTemplate
  viewPath={`${viewPath}/DocumentTemplate`}
/>
</div>
<div
  data-testid="LetterNew.Horizontal:4"
  data-view-path={viewPath}
 style={{'--pb-9-Z1bsJny': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal4}`}
>
<LetterRecipientPicker
  viewPath={`${viewPath}/LetterRecipientPicker`}
 autoSelect={true}
 offsetCrossAxis={-180}
 data="form.patient.id"
 patientId={formPatientIdValueData}
 data="form.action.recipient_id"
 recipientId={formActionRecipientIdValueData}
 data="form.action.postal_address_id"
 postalAddressId={formActionPostalAddressIdValueData}
 onSave={onSave}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}